import { css } from "lit"

export const fontStyles = css`
  /* Avenir Book - Regular weight */
  @font-face {
    font-family: "Avenir LT W01_45 Book1475508";
    src:
      url("https://fonts.your-cdn.com/AvenirLTW01-45Book1475508.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/AvenirLTW01-45Book1475508.woff")
        format("woff");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  /* Avenir Medium - Medium weight */
  @font-face {
    font-family: "AvenirLTW01-65Medium";
    src:
      url("https://fonts.your-cdn.com/AvenirLTW01-65Medium.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/AvenirLTW01-65Medium.woff") format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  /* Avenir Heavy - Bold weight */
  @font-face {
    font-family: "Avenir LT W01_65 Heavy1475544";
    src:
      url("https://fonts.your-cdn.com/AvenirLTW01-65Heavy1475544.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/AvenirLTW01-65Heavy1475544.woff")
        format("woff");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  /* Mercury Text for headings (alias) */
  @font-face {
    font-family: "HCo Mercury Text G2";
    src:
      url("https://fonts.your-cdn.com/MercuryTextG2-Regular.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/MercuryTextG2-Regular.woff")
        format("woff");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
`
